export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6365.0eff5e5c.jpg";